
import React from 'react';
import PropTypes from 'prop-types';

import {
  Slider,
  Typography
} from '@material-ui/core';

import './Range.scss';



export default function Range({
  chartTab,
  chartVisible,
  climateRange,
  hazardRange,
  mode,
  handleOptionsChange
}) {
  // Checks the validity of the new range
  const shiftTimeFrame = (newStart, newEnd, timeFrameObj, minRange) => {
    if (
      newStart >= timeFrameObj.min && 
      newStart <= timeFrameObj.max - minRange && 
      newEnd <= timeFrameObj.max &&
      newEnd >= timeFrameObj.min + minRange
    ) {
      let newRange = newEnd - newStart;

      if(newRange < minRange) {
        let shiftAmount = minRange - newRange;

        if (newStart === timeFrameObj.start) {
          let shiftedStart = newStart - shiftAmount;
          if (shiftedStart >= timeFrameObj.min) {
            newStart = shiftedStart;
          }
        } else if (newEnd === timeFrameObj.end) {
          let shiftedEnd = newEnd + shiftAmount;
          if (shiftedEnd <= timeFrameObj.max) {
            newEnd = shiftedEnd;
          }
        }
      }

      return { 
        min: timeFrameObj.min,
        max: timeFrameObj.max,
        start: newStart,
        end: newEnd
      };
    }
  };


  // Sets new range
  const handleChange = (event, newValue) => {
    if (mode) {
      let results = shiftTimeFrame(newValue[0], newValue[1], climateRange, 30);
      if (results) {
        handleOptionsChange(results, 'climateRange');
      }
    } else {
      let results = shiftTimeFrame(newValue[0], newValue[1], hazardRange, 5);
      if (results) {
        handleOptionsChange(results, 'hazardRange');
      }
    }
  };

  
  if (chartTab !== 0 && chartVisible && mode) {
    return (
      <div id="range" className="card" style={{overflow: 'hidden', padding: '0px'}}>
        <Typography variant="h5" component="h2" style={{ margin: '0 auto', textAlign: 'center', whiteSpace: 'break-spaces'}}>Climate Model Time Frame: <span style={{fontSize: '16px'}}>{new Date().getFullYear()} to 2099</span></Typography>
      </div>
    );
  } else {
    return (
      <div id="range" className="card">
        <Typography variant="h5" component="h2">Time Range:</Typography>
        <Slider
          id="slider"
          min={mode ? climateRange.min : hazardRange.min}
          max={mode ? climateRange.max : hazardRange.max}
          value={mode ? [climateRange.start, climateRange.end] : [hazardRange.start, hazardRange.end]}
          valueLabelDisplay="on"
          onChange={handleChange}
        />
      </div>
    );
  }
}

Range.propTypes = {
  chartTab: PropTypes.number,
  chartVisible: PropTypes.bool,
  climateRange: PropTypes.object,
  hazardRange: PropTypes.object,
  mode: PropTypes.bool,
  handleOptionsChange: PropTypes.func
};